/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum ConnectedIdentificationType {
    BySerialNumber = 1,
    ByDirectId = 2,
}
